import { Action } from '@ngrx/store';
import { DomicilioAppProductos } from '../../models/domiciliosappproductos.model';
export const CARGAR_PRODUCTOS_DOMICILIOS_SUCCESS = '[Cargar productos domicilios] Cargar productos domicilios success';
export const CARGAR_PRODUCTOS_DOMICILIOS_FAIL = '[Cargar productos domicilios Fail] Caragar productos domicilios Fail';

export class CargarProductosDomiciliosSuccessActions implements Action {
  readonly type = CARGAR_PRODUCTOS_DOMICILIOS_SUCCESS;

  constructor ( public payload: DomicilioAppProductos[]) {}
}

export class CargarProductosDomiciliosFailActions implements Action {
  readonly type = CARGAR_PRODUCTOS_DOMICILIOS_FAIL;

  constructor ( public payload: any ) {}
}

export type CargarproductosAcciones = CargarProductosDomiciliosSuccessActions
                                      | CargarProductosDomiciliosFailActions;



// WEBPACK FOOTER //
// ./src/store/actions/domiciliosappproductos.actions.ts